export const chosenMessageStyle = "card mb-2 pointer p-2 shadow-sm border border-primary";

export const selectedEntityStyle = "card shadow-sm border border-primary py-2";

export const disabledCardStyle = "card lightCardNoHover bg-light py-2";